import React from 'react';

interface props {
  deliverydata: any[];
  openedit: (item: any) => void;
}

// AdminDeliveryTable: display-only grid of delivery records
const AdminDeliveryTable: React.FC<props> = ({ deliverydata, openedit }) => {
  const handleaction = (item: any, action: string) => {
    if (action === 'edit') {
      openedit(item);
    }
  };

  const rows = deliverydata.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select
          className="action-select"
          value=""
          onChange={(e) => handleaction(item, e.target.value)}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
        </select>
      </td>
      <td>{item.deliverydate || '-'}</td>
      <td><strong>{item.customername || '-'}</strong></td>
      <td>{item.address || '-'}</td>
      <td>
        {item.items && item.items.map((it: any, idx: number) => (
          <div key={idx}>{it.quantity} x {it.name || it.productid}</div>
        ))}
      </td>
      <td><span className={`status-badge ${item.status}`}>{item.status || '-'}</span></td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>date</th>
          <th>customer</th>
          <th>address</th>
          <th>items</th>
          <th>status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={6} style={{ textAlign: 'center', padding: '16px' }}>No deliveries found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdminDeliveryTable;
